export default "__VITE_ASSET__B4WKyhPE__"